import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mensaje-label-negocio',
  templateUrl: './mensaje-label-negocio.component.html',
  styleUrls: ['./mensaje-label-negocio.component.css']
})
export class MensajeLabelNegocioComponent {

  @Input() mensaje: String[];

  constructor() { }

  close(index: number) {
    this.mensaje.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/mensaje-label-negocio/mensaje-label-negocio.component.ts